


























































































import Vue from "vue";
import Component from "vue-class-component";
import { IPromotionGridModel } from "../../models";
import { Inject } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import { GridOptions } from "ag-grid-community";
import { AjaxDataSource, initializeTable } from "../../table";
import PromotionManagementEvents from "./PromotionManagementEvents";
import { DefaultGridOptions } from "../../table";
import { EditPromotionRoute } from "../../router";

@Component
export default class PromotionManagement extends Vue {
    @Inject()
    restClient!: RestClient;

    gridOptions: GridOptions = new DefaultGridOptions();

    dataSource!: AjaxDataSource<IPromotionGridModel>;

    get pathName() {
        return EditPromotionRoute.name;
    }

    get deleteEventName() {
        return PromotionManagementEvents.gridRefreshEvent;
    }

    mounted(): void {
        this.dataSource = new AjaxDataSource<IPromotionGridModel>(
            this.restClient,
            "/api/PromotionGrid"
        );

        initializeTable(
            this.gridOptions,
            this.dataSource,
            this.deleteEventName,
            this
        );
    }
}
